exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content{margin-top:25px}.aside{position:fixed;top:0;left:0;bottom:0;z-index:10000;border-right:1px solid #ccc;background:#ddd;padding:75px 0 30px;width:250px;transform:translateX(calc(-100% + 20px));transition:transform .4s ease}.aside.active{transform:translateX(0)}.aside .btn-collapse{border-radius:100%;background:#008ed1;width:30px;height:30px;padding:2px 3px;position:absolute;right:-15px;top:22px;transform:scale(1);transition:transform .2s ease}.aside.active .btn-collapse{transform:scale(-1)}.aside .btn-collapse:focus,.aside .btn-collapse:hover{outline:none}.aside .btn-collapse .icon{color:#fff;font-size:24px}.aside .nav li a{font-size:18px;padding:15px 30px;transition:color .2s ease}.aside .nav li a:hover{color:#337ab7}.aside.active .nav li a.active{color:#337ab7;border-left:5px solid #337ab7;padding-left:25px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./yii2/frontend/frontend-assets/src/components/AdminPanel/Submenu.css
// module id = 2778
// module chunks = 0